/* @flow */

export default {
  root: {
    marginBottom: 60,
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
};
